#import "../fragments/stageset-context-fragment.graphql"
#import "../fragments/product-context-fragment.graphql"

query GetSalesProcessContext {
    pipelines: stagesets {
        ...StagesetContext
    }
    products {
        edges {
            node {
                ...ProductContext
            }
        }
    }
}
